export enum Chain {
    ethereumMainnet = 1,
    ethereumRinkeby = 4,
    binanceTestnet = 97,
    binanceMainnet = 56
}